// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2Rkp8","col":"styles_col__33-it"};